import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {BE_API_AUTH_URL, BE_API_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class KBService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getArticles(): Observable<any> {
    const url = `${BE_API_URL}/kb`;
    return this.http.get<any>(url);
  }

  createArticle(article: any): Observable<any> {
    const headers = this.authService.createAuthorizationHeader();
    return this.http
      .post(`${BE_API_URL}/auth/kb`, article, { headers })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateArticle(id: string, article: any): Observable<any> {
    const headers = this.authService.createAuthorizationHeader();
    return this.http
      .put(`${BE_API_URL}/auth/kb/${id}`, article, { headers })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  deleteArticle(id: string): Observable<any> {
    const headers = this.authService.createAuthorizationHeader();
    return this.http
      .delete(`${BE_API_URL}/auth/kb/${id}`, { headers })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
  uploadImage(formData: FormData): Observable<any> {
    const headers = this.authService.createAuthorizationHeader();
    return this.http.post(`${BE_API_URL}/auth/kb/upload-image`, formData, { headers });
  }
  askAI(questionOrPayload: string | any, language?: string): Observable<any> {
    const payload = typeof questionOrPayload === 'string'
      ? { question: questionOrPayload, language }
      : questionOrPayload;

    return this.http.post(`${BE_API_URL}/kb/ask`, payload);
  }
  getGroupedArticles(): Observable<any> {
    return this.http.get(`${BE_API_URL}/kb/grouped`);
  }
  searchArticles(query: string): Observable<any[]> {
    return this.http.get<any[]>(`${BE_API_URL}/kb/search`, { params: { q: query } });
  }
  sendFeedback(data: any): Observable<any> {
    return this.http.post(`${BE_API_URL}/kb/feedback`, data);
  }
  getFeedback(): Observable<any[]> {
    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/kb/feedback`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
